// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileView_wrapper__T720c"};